import _ from "lodash";

export const pascalCaseToCamelCase = (pascalCaseString: string) => {
  return _.camelCase(pascalCaseString);
};
